export const START_SEARCH = 'Type to start searching';
export const NO_RESULTS = 'No results found';
export const ERROR = 'Something went wrong';
export const SELECT_BUTTON_DISABLED_MESSAGE = "Action disabled per your clinic's preference";
